var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.361,
    height: 14.557,
    fill: "#fff",
    viewBox: "0 0 8.361 14.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.562 0.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99,6.715.151,12.553a.517.517,0,0,0,.731.731l6.2-6.2a.517.517,0,0,0,0-.731L.882.145A.517.517,0,0,0,.151.876Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWLeftArrow);
export default __webpack_public_path__ + "static/media/w-left-arrow.06bdc3026a86e0aba6e7e25c40ac5a92.svg";
export { ForwardRef as ReactComponent };